import * as React from 'react';
import { AssistentItem } from '../assistent_config';
import { HinweiseElement } from './custom/HinweiseElement';
import { renderText } from '../assistent_helpers';
import { isProduzierendesGewerbe } from '../../../../main/functions/getGewerk';
import style from '../Assistent.less';

export function getAssistentConfigEingangsHinweise(data: any, cumstomCfg?: any): AssistentItem {
    const eingangs_hinweise = {
        gliederung: '2.',
        name: 'Energiedaten',
        description: '',
        type: 'CustomElement',
        customElements: [renderHinweiseElement(data)],
        ...(cumstomCfg || {})
    };
    return eingangs_hinweise;
}

export function getAssistentConfigCustom(data: any, config: any, systemtexte: string): AssistentItem {
    const eingangs_hinweise = {
        type: 'CustomElement',
        customElements: [
            <div className={style.customFormInfotext}>
                {renderText(systemtexte, data)}
            </div>
        ],
        ...config
    };
    return eingangs_hinweise;
}

function renderHinweiseElement(data: any): JSX.Element {
    if (data.MODUL_SELECTED === 'steuer') {
        const isProduGewebe: boolean = isProduzierendesGewerbe(data);
        if (!isProduGewebe) {
            return <div className={style.customFormInfotext}>
                {renderText('Kein produzierendes Gewerbe', data)}
            </div>;
        } else {
            return <div className={style.customFormInfotext}>
                {renderText('Geführter Modus - Hinweis Dateneingabe (Steuer)', data)}
            </div>;
        }
    } else {
        return (
            <HinweiseElement
                data={data}
            />
        );
    }
    return null;
}